import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import "../App.css";
import {
  setRoomEnergyDataFirstValue,
  setscenarioDescriptionList,
} from "../redux/roomData";
import { setGlobalSceneVariable, updateCamera } from "../redux/sceneGlobal";
import Convas from "./Convas";
import Filter from "./Filter";
import WindAlarmMetricSelector from "./WindAlarmMetricSelector";
import DaylightInfoBoxView from "./InformationBox/DaylightBoxView";
import EnergyDataInfoBox from "./InformationBox/EnergyDataInfoBox";
import RoomConfiguration from "./InformationBox/RoomConfiguration";
import SensorPlacementInfoBox from "./InformationBox/SensorPlacementInfoBox";
import VirtualSensorsInfoBox from "./InformationBox/VirtualSensorsInfoBox";
import WindGif from "./InformationBox/WindGif";
import WindAlarmWindowInfoBox from "./InformationBox/WindAlarmWindowInfoBox";
import WindRiskInfoBox from "./InformationBox/WindRiskInfoBox";
import WindowConfiguration from "./InformationBox/WindowConfiguration";
import ScenarioModal from "./ScenarioModal";
import ColorBarDaylightFactor from "./colorBarComponent/ColorBarDaylightFactor";
import ColorBarEnergyData from "./colorBarComponent/ColorBarEnergyData";
import ColorBarPV from "./colorBarComponent/ColorBarPV";
import ColorBarSolarSensors from "./colorBarComponent/ColorBarSunHours";
import ColorBarWindAlarm from "./colorBarComponent/ColorBarWindAlarm";
import ColorBarWindRisk from "./colorBarComponent/ColorBarWindRisk";
import ColorBarPanel from "./colorBarComponent/ColorBarPanel";
import SensorPlacementColorBar from "./colorBarComponent/SensorPlacementColorBar";
import VirtualWindColorBar from "./colorBarComponent/VirtualWindColorBar";
import NavBar from "./navBar/NavBar";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { Dropdown, DropdownItem, DropdownMenu } from "semantic-ui-react";
import { updatePVDataFilter } from "../redux/pvData";
import { setIsMenuOpen, updatePVPanelFilter } from "../redux/sceneSlice";
import { updateUser } from "../redux/user";
import ActivityTracker from "./ActivityTracker";
import Authenticator from "./Authenticator";
import WindTurbineInfoBox from "./InformationBox/WindTurbineInfoBox";
import LoggedoutModal from "./LoggedoutModal";
import RoomFilter from "./RoomFiltler";
import ShadingProgressionSelector from "./ShadingProgressionSelector";
import TokenRefresher from "./TokenRefresher";
import WindTurbineColorBar from "./colorBarComponent/WindTurbineColorBar";
import SoundEmissionColorBar from "./colorBarComponent/SoundEmissionColorBar";
import SoundEmissionInfoBox from "./InformationBox/SoundEmissionInfoBox";
import { publish, windowEvents } from "./events";
import Compass from "./threeDComponent/Compass";
import { EmptyErrorBoundary } from "./utility/ErrorBoundary";
import { parseJsonList } from "./utility/parseJson";
import { CaptureComponent } from "./utility/ScreenShotTaker";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { FaVideo } from "react-icons/fa6";
import { GiPhotoCamera } from "react-icons/gi";
import { reduxLocalStorage } from "./utility/storage";
import { useHandleCallerAppMessages, useResetAllFilters } from "./CustomHooks";
import HeatmapLabelsToggle from "./HeatmapLabelsToggle";
import { useTheme } from "../styles/themes/themeContext";
import {
  defaultTheme,
  getIsDefaultTheme,
} from "../styles/themes/themeSelection";
import { ClientLogo, LeaftechLogo } from "./Logo";
import PoweredBy from "./PoweredBy";
import ExecutionToolbox from "./ExecutionToolbox";
import WindowFilters from "./WindowFilters";
import { setWindowFilters } from "../redux/windowData";
import { isResourceInState } from "../redux/sensorAnalysis";
import { resources } from "../redux/sensorAnalysisConstants";
import PVDesignRoot from "./pvDesign/PVDesignRoot";
import SensorAnalysisRoot from "./sensorAnalysis/SensorAnalysisRoot";
import RBToaster from "./RBToaster";
import ObjectPlacementControls from "./objectPlacement/Controls";
import PolygonPlacementControls from "./objectPlacement/PolygonPlacementControls";
import "./sensorAnalysis/SensorAnalysis.css";

import SoundEmissionLrMaxSlider from "./SoundEmissionLrMaxSlider";
const decodeQueryParam = (param) => {
  // Replace URL-encoded characters and decode the parameter value
  return decodeURIComponent(
    param.replace(/%[0-9A-Fa-f]{2}/g, (match) =>
      String.fromCharCode(parseInt(match.substring(1), 16)),
    ),
  );
};

const removeNoscriptTags = () => {
  document.querySelectorAll("noscript")?.forEach((noscript) => {
    noscript.style.display = "none";
  });
};

const restoreNoscriptTags = () => {
  document.querySelectorAll("noscript")?.forEach((noscript) => {
    noscript.style.display = "";
  });
};

const CapturePageButton = () => {
  const capturePage = () => {
    removeNoscriptTags();

    html2canvas(document.body, {
      useCORS: true,
    }).then((canvasSnapshot) => {
      const screenshot = canvasSnapshot.toDataURL("image/png");
      saveAs(screenshot, "page-screenshot.png");
    });
    restoreNoscriptTags();
  };

  return (
    <button
      onClick={capturePage}
      style={{
        border: "1px solid #ddd",
        background: "transparent",
        borderRadius: "4px",
        cursor: "pointer",
        width: "42px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <GiPhotoCamera
        style={{
          width: "34px",
          height: "34px",
          padding: 4,
        }}
      />
    </button>
  );
};

const TopMenu = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMenuOpen = useSelector((state) => state.sceneVisibility.isMenuOpen);
  const buildingsInfo = useSelector((state) => state.sceneVar.buildingsInfo);
  const [hovered, setHovered] = useState(false);
  const allWindows = useSelector((state) => state.windowData.allWindows);
  const windowFilters = useSelector((state) => state.windowData.filters);
  const floors = useSelector((state) => state.sceneVar.floorsList) || [];
  const sensorAnalysisState = useSelector(
    (state) => state.sensorAnalysis.sensorAnalysisState,
  );
  const windowFiltersVisible = isResourceInState(
    sensorAnalysisState,
    resources.WINDOW_FILTERS,
  );

  let mainScene = useRef();
  let mainScene1 = useRef();

  // const { cameraTarget } = useSelector(store => store.sceneVar)
  return (
    <div
      className="TopBar"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        transition: "all 0.4s linear",
        zIndex: 9,
        pointerEvents: "none",
      }}
    >
      {isMenuOpen && (
        <>
          <div
            className="top-menu-row top-menu-row--title"
            style={{ pointerEvents: "auto" }}
          >
            <div className="company-logo">
              <ClientLogo imgProps={{ style: { height: theme.logo.height } }} />
            </div>
            <div className="Title">
              <p
                style={{
                  marginBottom: "0px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span>
                  {reduxLocalStorage.getItem("bulidingName") ?? "3D Viewer"}
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    marginLeft: "8px",
                  }}
                >
                  {reduxLocalStorage.getItem("bulidingAddress") ?? ""}
                </span>
              </p>
            </div>
          </div>

          <div
            className="top-menu-row top-menu-row--nav"
            style={{ pointerEvents: "auto" }}
          >
            <NavBar value={mainScene} valuef={mainScene1} />
          </div>

          <div
            className="top-menu-row top-menu-row--filters"
            style={{ pointerEvents: "auto" }}
          >
            <Filter />
          </div>
        </>
      )}

      <div
        className="top-menu-row top-menu-row--tools"
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 16,
          padding: "4px 10px 8px",
          pointerEvents: "auto",
        }}
      >
        <div
          style={{
            width: "42px",
            background: "white",
            cursor: "pointer",
            border: "1px solid #ddd",
            height: "32px",
            borderRadius: "4px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => dispatch(setIsMenuOpen(!isMenuOpen))}
        >
          {!isMenuOpen && <KeyboardDoubleArrowDownIcon stroke="#666" />}
          {isMenuOpen && <KeyboardDoubleArrowUpIcon stroke="#666" />}
        </div>
        <CaptureComponent
          targetElement={() => document.body}
          style={{
            border: "1px solid #ddd",
            borderRadius: "4px",
            width: "40px",
            height: "32px",
            padding: 3,
            flexShrink: 0,
            background: "white",
            boxSizing: "border-box",
          }}
          id="Home-Capture-Button"
        />
        <div style={{ width: "60px", flexShrink: 0 }}>
          <Dropdown
            style={{
              border: "1px solid #ddd",
              color: "black",
              borderRadius: "7px",
              height: "34px",
              alignItems: "center",
              padding: "4px 8px 2px 8px",
              background: "white",
              cursor: "pointer",
            }}
            icon={
              <FaVideo
                style={{
                  transform: "rotate(25deg)",
                  width: "20px",
                  height: "24px",
                  cursor: "pointer",
                }}
              />
            }
          >
            <DropdownMenu>
              {!buildingsInfo?.length && (
                <DropdownItem
                  onClick={() => publish(windowEvents.RESET_CAMERA)}
                >
                  Reset
                </DropdownItem>
              )}
              {buildingsInfo?.length > 0 &&
                buildingsInfo?.map((building, i) => {
                  return (
                    <DropdownItem
                      key={building.name || i}
                      onClick={() => {
                        publish(windowEvents.RESET_CAMERA);
                        dispatch(updateCamera(building.coordinates));
                      }}
                    >
                      {building.name}
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          </Dropdown>
        </div>
        {/* <ExecutionToolbox /> */}
        <WindAlarmMetricSelector />
        <HeatmapLabelsToggle />
        {windowFiltersVisible && (
          <WindowFilters
            allWindows={allWindows}
            floors={floors}
            filters={windowFilters}
            onFiltersChange={(filters) => dispatch(setWindowFilters(filters))}
          />
        )}
      </div>
    </div>
  );
};

export default function Project() {
  var dispatch = useDispatch();

  let [searchParams, setSearchParams] = useSearchParams();
  const [resultArray, setResultArray] = useState();

  const token = searchParams.get("token");
  const project_id = searchParams.get("project_id");
  reduxLocalStorage.setItem("project_id", project_id);
  localStorage.setItem("token", token);

  const { isMinified } = useHandleCallerAppMessages();

  useEffect(() => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    if (!resultArray?.length && token && project_id !== undefined)
      axios
        .all([
          axios.get(
            `${process.env.REACT_APP_API_URL_2}api/projects/${project_id}/project_info`,
            {
              headers,
            },
          ),
          axios.get(
            `${process.env.REACT_APP_API_URL}api/projects/${project_id}/get_project_details/`,
            {
              headers,
            },
          ),
        ])
        .then(([response, projectDetails]) => {
          const descriptiveName = projectDetails?.data?.descriptive_name;
          const name = projectDetails?.data?.name;
          reduxLocalStorage.setItem("bulidingName", descriptiveName ?? name);

          const address = projectDetails?.data?.address;
          reduxLocalStorage.setItem("bulidingAddress", address);

          const projectInfo = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          setResultArray(projectInfo);

          reduxLocalStorage.setItem(
            "scenario_list",
            JSON.parse(projectInfo.all_scenario_list),
          );
          reduxLocalStorage.setItem(
            "floor_list",
            JSON.parse(projectInfo.floor_list),
          );
          reduxLocalStorage.setItem(
            "value_list",
            JSON.parse(projectInfo.energy_value_list),
          );
          let floorsList;
          var energyValueData;
          let scenarioList;
          floorsList = reduxLocalStorage.getItem("floor_list");
          scenarioList = reduxLocalStorage.getItem("scenario_list");
          energyValueData = reduxLocalStorage.getItem("value_list");
          floorsList = floorsList.split(",");
          scenarioList = scenarioList.split(",");
          energyValueData = energyValueData.split(",");

          var dict = {};
          for (let i = 0; i < floorsList.length; i++) {
            for (let j = 0; j < energyValueData.length; j++) {
              for (let k = 0; k < scenarioList.length; k++) {
                dict[
                  `${floorsList[i]}${energyValueData[j]}${scenarioList[k]}`
                ] = false;
              }
            }
          }
          dispatch(setRoomEnergyDataFirstValue([dict]));
        })
        .catch((response) => {
          if (
            response.response?.status === 401 ||
            response.response?.status === 403
          )
            dispatch(updateUser({ isNotAuthorized: true }));
        });
  }, [project_id, token]);

  if (resultArray) {
    const wholeData = resultArray;
    reduxLocalStorage.setItem(
      "scenario_list",
      JSON.parse(wholeData?.all_scenario_list),
    );
    reduxLocalStorage.setItem("floor_list", JSON.parse(wholeData?.floor_list));
    reduxLocalStorage.setItem(
      "value_list",
      JSON.parse(wholeData?.energy_value_list),
    );

    reduxLocalStorage.setItem(
      "daylight_value_list",
      JSON.parse(wholeData?.daylight_value_list),
    );

    if (wholeData?.daylight_scenario_list)
      reduxLocalStorage.setItem(
        "daylight_scenario_list",
        JSON.parse(wholeData?.daylight_scenario_list),
      );

    var scenarioDescription = JSON.parse(wholeData?.scenario_description);
    var allWindDirections = JSON.parse(wholeData?.all_wind_direction);
    if (allWindDirections?.length) allWindDirections?.sort((a, b) => a - b);

    let pvScenarios;
    try {
      pvScenarios = JSON.parse(wholeData?.pv_panel_data);
    } catch {
      pvScenarios = undefined;
    }

    let pvPanelList = wholeData?.pv_panels;
    if (pvPanelList)
      try {
        pvPanelList = JSON.parse(pvPanelList);
      } catch {
        pvPanelList = [pvPanelList];
      }

    let locationCoordinates = JSON.parse(
      wholeData?.location_coordinate ?? "[[0,0,0]]",
    );
    const isArray = Array.isArray(locationCoordinates[0]);
    const buildingsInfo = isArray ? locationCoordinates : [locationCoordinates];

    const buildingsInfoInModelSpace = buildingsInfo.map((building, i) => ({
      name: buildingsInfo?.length > 1 ? `B${i + 1}` : "Reset",
      coordinates: [building[0], building[2], -building[1]],
    }));

    dispatch(updateCamera(buildingsInfoInModelSpace[0].coordinates));
    publish(windowEvents.RESET_CAMERA);

    const shadingControlScenarios = parseJsonList(
      wholeData?.shading_control_scenario,
    );

    dispatch(
      setGlobalSceneVariable([
        JSON.parse(wholeData?.ceiling_list),
        JSON.parse(wholeData?.floor_list),
        JSON.parse(wholeData?.external_list),
        JSON.parse(wholeData?.internal_list),
        JSON.parse(wholeData?.all_scenario_list),
        JSON.parse(wholeData?.energy_value_list),
        allWindDirections,
        pvPanelList,
        wholeData?.rooftop,
        JSON.parse(wholeData?.stairs),
        wholeData?.sensor_placement,
        wholeData?.shading_progression,
        wholeData?.wind_risk,
        JSON.parse(wholeData?.stairs),
        JSON.parse(wholeData?.doors),
        JSON.parse(wholeData?.wind_risk_directions_list),
        pvScenarios,
        buildingsInfoInModelSpace,
        (() => {
          const raw = wholeData?.sensor_placement_zone_config;
          if (Array.isArray(raw)) return raw;
          try {
            return JSON.parse(raw ?? "null");
          } catch {
            return null;
          }
        })(),
        wholeData?.shading_progression_step,
        wholeData?.shading_progression_date,
        shadingControlScenarios,
        wholeData?.sound_emission,
      ]),
    );
    dispatch(setscenarioDescriptionList([scenarioDescription]));

    if (pvScenarios?.length) {
      const pvDataFilters = {};
      for (const index in pvScenarios) {
        pvDataFilters[pvScenarios[index]] = false;
      }
      dispatch(updatePVDataFilter(pvDataFilters));
    }
    if (pvPanelList?.length) {
      const pvPanelsFilters = {};
      for (const index in pvPanelList) {
        pvPanelsFilters[pvPanelList[index]] = index === "0";
      }
      dispatch(updatePVPanelFilter(pvPanelsFilters));
    }
  }
  // const blockAccess =
  //   user?.isNotAuthorized ||
  //   user?.isAuthenticated === false ||
  //   user?.isInactive;
  const blockAccess = false;
  return (
    <>
      <ActivityTracker />
      <Authenticator />
      <TokenRefresher />
      {blockAccess && <LoggedoutModal />}
      {!blockAccess && resultArray && (
        <Suspense fallback={<LinearProgress />}>
          <div style={{ width: "100vw" }}>
            {!isMinified && (
              <>
                <TopMenu />
                <PoweredBy />
                <EmptyErrorBoundary>
                  <RoomFilter />
                </EmptyErrorBoundary>

                <EmptyErrorBoundary>
                  <ColorBarPanel>
                    <ColorBarSolarSensors />
                    <ColorBarWindRisk />
                    <ColorBarWindAlarm />
                    <ColorBarEnergyData />
                    <SensorPlacementColorBar />
                    <WindTurbineColorBar />
                    <SoundEmissionColorBar />
                    <VirtualWindColorBar />
                    <ColorBarDaylightFactor />
                    <ColorBarPV />
                  </ColorBarPanel>
                </EmptyErrorBoundary>

                <ScenarioModal />

                <EmptyErrorBoundary>
                  <WindowConfiguration />
                  <RoomConfiguration />
                  <VirtualSensorsInfoBox />
                  <WindRiskInfoBox />
                  <WindAlarmWindowInfoBox />
                  <EnergyDataInfoBox />
                  <DaylightInfoBoxView />
                  <SensorPlacementInfoBox />
                  <WindTurbineInfoBox />
                  <SoundEmissionInfoBox />
                </EmptyErrorBoundary>
                <SoundEmissionLrMaxSlider />
              </>
            )}
            <EmptyErrorBoundary>
              <WindGif />
              <PVDesignRoot />
              <ObjectPlacementControls />
              <PolygonPlacementControls />
              <SensorAnalysisRoot />
            </EmptyErrorBoundary>
            {!isMinified && (
              <>
                <EmptyErrorBoundary>
                  <ShadingProgressionSelector />
                </EmptyErrorBoundary>
              </>
            )}
            <EmptyErrorBoundary>
              <Compass isMinified={isMinified} />
            </EmptyErrorBoundary>
            <Convas isMinified={isMinified} />
            <RBToaster />
          </div>
        </Suspense>
      )}
    </>
  );
}
